import React, { useState, useRef, useEffect } from "react";
import { FaCaretDown } from "react-icons/fa6";
import "./MultiselectDropdown.scss";
export type viewType = "verticale" | "horizontal";
export type mode = "light" | "dark";


type MultiSelectDropdownProps = {
  options: any; // Options array
  selected: string[]; // Selected values
  onChange: (selected: string[]) => void; // Callback for selection change
  mainClassName?: string;
  dropContentClass?: string;
  dropClassName?: string;
  mainId?: string;
  dropId?: string;
  dropdownLabel?: string;
  placeHolder?: string;
  view?: viewType;
  dropdownMode?: mode;
};

const MultiSelectDropdown: React.FC<MultiSelectDropdownProps> = ({
  options,
  selected,
  onChange,
  mainClassName,
  mainId,
  dropdownLabel,
  dropClassName,
  dropId,
  dropContentClass,
  view = "verticale",
  placeHolder = "Select Value...",
  dropdownMode = "light",
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const toggleDropdown = () => setIsOpen(!isOpen);
  const ref = useRef<any>(null);
  const butref = useRef<any>(null);
  const dropref = useRef<any>(null);
  const handleSelect = (value: string) => {
    if (selected.includes(value)) {
      onChange(selected.filter((item) => item !== value));
    } else {
      onChange([...selected, value]);
    }
  };
  const clearSelection = () => {
    onChange([]);
  };
  const handleClickOutside = (event: any) => {
    if (ref.current && !ref.current.contains(event.target)) {
      setIsOpen(false);
    }
  };
  useEffect(() => {
    if (isOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }
    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape") {
        setIsOpen(false);
        butref?.current?.focus();
      }
    });
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isOpen]);
  return (
    <div
      className={`mfg-dropdown-wrapper mfg-multiSelect${
        mainClassName ? " " + mainClassName : ""
      } ${view}${dropdownMode ? " " + dropdownMode : ""}`}
      id={mainId}
      ref={ref}
    >
      {dropdownLabel && <label htmlFor={dropId}>{dropdownLabel}</label>}
      {/* Dropdown Toggle */}
      <div className="dropdownText">
        <button
          onClick={toggleDropdown}
          className={`dropDown${dropClassName ? " " + dropClassName : ""}`}
          aria-expanded={isOpen ? "true" : "false"}
          ref={butref}
        >
          {selected.length > 0 ? `${selected}` : placeHolder}
         
        </button>
        {selected.length > 0 ? (
            <button
              onClick={clearSelection}
              className="dropicon" 
            >
              X
            </button>
        ) : (
          <button onClick={toggleDropdown} className="dropicon" tabIndex={-1}>
          <FaCaretDown/>
        </button>
          )}
          
        {/* Dropdown List */}
        {isOpen && (
          <div
            className={`dropContent${
              dropContentClass ? " " + dropContentClass : ""
            }`}
            ref={dropref}
            aria-labelledby={mainId}
          >
            <ul role="listbox" aria-activedescendant={ options }>
              {options.map((option: any, index: number) => (
                <li key={ index}   role="option">
                  <input
                    type="checkbox"
                    checked={selected.includes(option)}
                    onChange={() => handleSelect(option)}
                    id={`${option}-${index}`}
                  />
                  <label htmlFor={`${option}-${index}`}>{option}</label>
                </li>
              ))}
            </ul>
          </div>
        )}
      </div>
    </div>
  );
};

export default MultiSelectDropdown;
